import { uuid } from "lib/uid";
import { CHAT_KEY, MAX_CHAT_ENTRIES } from "./chatConsts";

export const getChatEntry = (entry = {}) => {
  const { id = uuid(), dateAdded = Date.now(), ...rest } = entry;
  return {
    id,
    dateAdded,
    ...rest,
  };
};

export const addChatEntry = (original = [], entry) => [
  getChatEntry(entry),
  ...original.slice(0, MAX_CHAT_ENTRIES - 1),
];

export const addChatEntryToDB = ({ update, groupId, entry }) => {
  return update(groupId, (doc) => {
    let prevChat = doc.data()[CHAT_KEY] || [];

    // console.log({
    //   prevRolls,
    //   newRolls: [
    //     {
    //       id: uuid(),
    //       label: name,
    //       user: userName,
    //       value: diceResult,
    //       dateAdded: new Date(),
    //     },
    //     ...prevRolls,
    //   ],
    // });

    return {
      [CHAT_KEY]: addChatEntry(prevChat, entry),
    };
  });
};
